function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M.84 14h18.32a10 10 0 000-8H.84a10 10 0 000 8z",
  fill: "#00966e"
});

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M19.16 14H.84a10 10 0 0018.32 0z",
  fill: "#d62612"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M.84 6h18.32A10 10 0 00.84 6z",
  fill: "#f0f0f0"
});

function SvgBg(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    "data-name": "Capa 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20"
  }, props), _ref, _ref2, _ref3);
}

export default "data:image/svg+xml;base64,PHN2ZyBpZD0iQ2FwYV8xIiBkYXRhLW5hbWU9IkNhcGEgMSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIiB2aWV3Qm94PSIwIDAgMjAgMjAiPjxkZWZzPjxzdHlsZT4uY2xzLTF7ZmlsbDojMDA5NjZlO30uY2xzLTJ7ZmlsbDojZDYyNjEyO30uY2xzLTN7ZmlsbDojZjBmMGYwO308L3N0eWxlPjwvZGVmcz48cGF0aCBjbGFzcz0iY2xzLTEiIGQ9Ik0uODQsMTRIMTkuMTZhMTAsMTAsMCwwLDAsMC04SC44NGExMCwxMCwwLDAsMCwwLDhaIi8+PHBhdGggY2xhc3M9ImNscy0yIiBkPSJNMTkuMTYsMTRILjg0YTEwLDEwLDAsMCwwLDE4LjMyLDBaIi8+PHBhdGggY2xhc3M9ImNscy0zIiBkPSJNLjg0LDZIMTkuMTZBMTAsMTAsMCwwLDAsLjg0LDZaIi8+PC9zdmc+";
export { SvgBg as ReactComponent };